<template>
  <div
    class="landing-page__reviews"
    :style="`background: ${props.section?.backgroundColor || '#ffffff'}`"
    :class="`landing-page__reviews-collumns-${reviewCollumns}`"
  >
    <div class="title" v-if="section.title">
      {{ section.title }}
    </div>

    <div :class="section.title ? `mt-md`: ' py-xs'">
      <sib-carousel
        v-if="
          transformedCustomerImageReviewsProps &&
          transformedCustomerImageReviewsProps.length
        "
        :items="transformedCustomerImageReviewsProps"
        :options="carouselOptions"
      >
        <template #default="{ item }">
          <div class="review">
            <sib-link v-if="item.url" :to="item.url" :title="item.title">
              <img :src="item.src" :alt="item.title" loading="lazy" />
            </sib-link>
            <img v-else :src="item.src" :alt="item.title" />
          </div>
        </template>
      </sib-carousel>
    </div>

    <div
      class="explore-more text--center"
      v-if="section.button?.text && section.button?.link"
    >
      <sib-link
        class="sib-button sib-button--width-auto"
        :style="`background: ${section.button?.color};border-color: ${section.button?.color}; color:white;`"
        :to="section.button?.link"
        :title="section.button?.text"
      >
        {{ section.button?.text }}
      </sib-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CarouselOptions } from '@/types'
import { computed } from '@vue/reactivity'
const props = withDefaults(defineProps<{ section: any }>(), {})

const transformedCustomerImageReviewsProps = computed(() => {
  return props.section.reviewImages.map((item) => {
    return {
      src: item.image,
      alt: item.alt,
      title: item.alt,
      url: item.link,
    }
  })
})

const carouselOptions: CarouselOptions = {
  center: true,
  infinite: false,
}

const reviewCollumns = computed(() => {
  return props.section?.reviewColumns || 3
})
</script>

<style lang="scss">
.landing-page__reviews {
  .title {
    font-size: 23px;
    font-weight: bold;
    text-align: center;
    margin: 2rem 0;
    @include media-md-up {
      font-size: 26px;
    }
  }
  &-collumns-4 {
    .carousel {
      @include media-xl-up {
          --carousel-slide-width: calc((100% - 12em) / 4 - 1px) !important;
      }
    }
  }
  .carousel {
    --carousel-slide-width: calc((100% - 10em) / 1 - 1px);
    &__slide {
      margin-right: 1em;
      margin-left: 1px;
    }
    &__button.is-prev,
    &__button.is-next {
      border-radius: 1rem;
    }
    &__button.is-prev {
      left: 1.2rem;
    }
    &__button.is-next {
      right: 1.2rem;
    }

    @include media-xl-up {
      --carousel-slide-width: calc((100% - 15em) / 3 - 1px);
    }
  }
  .carousel__dots .carousel__dot {
    width: 20px;
    &::after {
      width: 15px;
      border-radius: 2px;
      height: 5px;
    }
  }
  .carousel__dot.is-selected {
    &::after {
      background: var(--coral-base);
    }
  }
  .review {
    img {
      border-radius: 10px;
    }
    &__title {
      margin-top: 1rem;
      font-size: 12px;
      font-weight: 500;
    }
    &__price {
      margin-top: 2px;
    }
    &__image {
      overflow: hidden;
      &:hover img {
        scale: 1.05;
      }
      img {
        border-radius: 10px;
        transition: all 0.5s ease-in-out;
      }
    }
    a:hover {
      text-decoration: none;
    }
  }
}
</style>
